export default {"src":"/_next/static/media/seeker.ca92d527.svg","height":60,"width":53,"blurWidth":0,"blurHeight":0};